const Dashboard_V3 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 21 19" width="21" height="19" fill="none">
            <path fill="currentColor" fillRule="evenodd" d="M1 2.5C1 1.67 1.67 1 2.5 1h14c.83 0 1.5.67 1.5 1.5V5H1V2.5ZM1 6v5h17V6H1Zm17 6H1v2.5c0 .83.67 1.5 1.5 1.5h14c.83 0 1.5-.67 1.5-1.5V12ZM2.5 0A2.5 2.5 0 0 0 0 2.5v12A2.5 2.5 0 0 0 2.5 17h14a2.5 2.5 0 0 0 2.5-2.5v-12A2.5 2.5 0 0 0 16.5 0h-14Z"></path>
        </svg>
    )
}

export default Dashboard_V3